<div class="cart-summary-box" [formGroup]="form">
  <h4 class="mb-8">{{ "APP.TRANSACTION_SUMMARY" | translate }}</h4>
  <div class="d-flex flex-stack fw-bold">
    <p class="mb-0 fs-4 fw-semibold">{{ "APP.TOTAL_PRICE" | translate }}:</p>
    <p class="mb-0 fs-2 fw-bold">
      {{ transaction_info?.price | currency : "฿" }}
    </p>
  </div>
  <div class="d-flex flex-stack my-3 mb-4">
    <div class="mb-0 fs-5 fw-semibold">
      {{ "APP.COURSE_DISCOUNT" | translate }}
    </div>
    <!-- Red is this palette's alarm colour and a discount of zero is not an
         alarm — "-฿0.00" in danger red read as something having gone wrong with
         the order. The saving is only coloured when there is one. -->
    <div class="mb-0 fs-4 fw-bold" [class.text-danger]="(transaction_info?.discount || 0) > 0">
      -{{ transaction_info?.discount || 0 | currency : "฿" }}

    </div>
  </div>

  <!-- TODO next phase -->
  @if(transaction_info.discount_code){
  <div class="d-flex flex-stack pt-3 pb-2 mt-2 border-top">
    <div class="mb-0 fs-5 fw-semibold">
      {{ "APP.DISCOUNT_CODE" | translate }}
    </div>
  </div>
  <div class="d-flex flex-stack pb-4 gap-4 align-items-start">
    <div class="mb-0 fs-5 fw-semibold">
      {{ transaction_info.discount_code.discount_code_name }}
    </div>
    <div class="mb-0 fs-4 fw-bold text-nowrap"
      [class.text-danger]="(transaction_info.discount_from_discount_code || 0) > 0">
      -{{ transaction_info.discount_from_discount_code | currency : "฿" }}
    </div>
  </div>

  }
  <div class="d-flex flex-stack py-8 pt-12 border-top">
    <div class="mb-0 fs-4 fw-semibold">{{ "APP.SUB_TOTAL" | translate }}</div>
    <div class="mb-0 fs-1 fw-bold">
      {{ transaction_info?.net_price | currency : "฿" }}
    </div>
  </div>

  <div class="row g-4 pt-8">
    <div class="m-0">
      <h4 class="text-gray-600 fw-semibold mb-2">
        {{ "APP.PAY_BY" | translate }}:
        <span class="text-gray-800">{{ "APP.BANK_TRANSFER" | translate }}</span>
      </h4>

      <!-- The tiles below are a radio group, and nothing said so: the heading
           read as a statement of fact ("paid by bank transfer") rather than as
           a question, so people attached a slip, found "ยืนยันชำระเงิน" still
           dead, and had no way to know a bank had to be picked first. -->
      @if(transaction_info.transaction_status_id === 2){
      @if(transaction_info?.net_price){
      <p class="fs-6 fw-semibold text-gray-800 mb-3">
        {{ "APP.CHOOSE_BANK" | translate }}
      </p>
      }
      }

      @if(transaction_info.transaction_status_id === 1){
      <div class="col-12 d-flex flex-row align-items-center gap-2 bg-light-info rounded p-3">
        <app-keenicon name="abstract-12" class="fs-2qx text-info"></app-keenicon>
        <span class="fs-6 fw-semibold text-info">{{ "APP.APPROVE_PROCESS" | translate }}...
        </span>
      </div>
      } @if(transaction_info.transaction_status_id === 2 && !transaction_info?.net_price){
      <!-- Nothing to transfer. A free course still creates an order row, and
           that row used to open the whole bank-transfer flow: choose a bank,
           attach a slip, confirm — for ฿0.00. The course is already in the
           classroom; say so instead of asking for money. -->
      <div class="col-12 d-flex flex-column gap-4" data-testid="nothing-to-pay">
        <div class="d-flex flex-row align-items-center gap-2 bg-light-success rounded p-3">
          <app-keenicon name="check-circle" class="fs-2qx text-success"></app-keenicon>
          <span class="fs-6 fw-semibold text-success">{{ "APP.NOTHING_TO_PAY" | translate }}</span>
        </div>
        <a class="btn btn-primary col-12" routerLink="/online-class">
          {{ "MENU.ONLINE_CLASS" | translate }}
        </a>
      </div>
      } @if(transaction_info.transaction_status_id === 2 && transaction_info?.net_price){

      <div class="d-flex flex-column gap-5 px-0" data-kt-buttons="true" data-kt-buttons-target="[data-kt-button]"
        data-kt-initialized="1">
        @for (bank of bankAcc; track $index) {
        <label
          class="bank-card btn btn-color-gray-600 btn-active-text-gray-800 border border-1 border-gray-200 border-active-primary w-100 px-4 d-flex flex-column transition-all"
          (click)="selectedBank(bank.id)" [ngClass]="{ active: bank.id === form.value.bank_id }">
          <input class="btn-check" type="radio" name="method" [value]="bank.id" />
          <div class="d-flex flex-row justify-content-between align-items-center gap-2">
            <div class="d-flex flex-row align-items-center">
              <!-- The seeded banks carry no logo, and `fileUrl + ""` is the
                   site root — so every order page rendered the browser's
                   broken-image glyph next to the bank name. -->
              @if (bank.image_url) {
              <img [src]="fileUrl + bank.image_url" class="w-35px h-35px object-fit-cover rounded me-4"
                [attr.alt]="bank?.bank_name" />
              } @else {
              <span
                class="w-35px h-35px rounded me-4 d-inline-flex align-items-center justify-content-center bank-card__mark">
                <app-keenicon name="bank" class="fs-4"></app-keenicon>
              </span>
              }

              <span class="fs-7 fw-semibold d-block">{{
                bank?.bank_name
                }}</span>
            </div>
            @if(bank.qr_code_image_url){
            <span class="fw-bold d-block w-auto">
              <app-keenicon name="scan-barcode" class="fs-4 mt-2 svg svg-icon"></app-keenicon>
            </span>
            }
          </div>
          <div class="bank-content-wrapper overflow-hidden">
            @if(bank.id === form.value.bank_id){
            <div class="separator my-3 my-md-4"></div>
            <div class="text-start">
              <p class="fs-6 text-gray-800 fw-semibold mb-0">
                {{ "APP.ACCOUNT_NAME" | translate }} :
                {{ bank.bank_account_name }}
              </p>
              <p class="fs-6 text-gray-800 fw-semibold mb-0">
                {{ "APP.ACCOUNT_NO" | translate }} :
                {{ bank.bank_account_no | mask : "000-0-00000-0" }}
              </p>
              @if(bank.qr_code_image_url){
              <div class="separator my-2"></div>

              <img [src]="fileUrl + bank.qr_code_image_url" class="w-100 rounded me-4" />

              }
            </div>

            }
          </div>
        </label>
        }
        <section #paymentFooter class="col-12 d-flex flex-column gap-4 pt-4">
          <p class="mb-0 fs-4 fw-semibold">
            {{ "APP.ATTACH_SLIP" | translate }}
          </p>
          <app-file-upload formControlName="image" [accept]="'.jpg , .png , .heic'"></app-file-upload>
          <div class="col-12">
            <button class="btn btn-primary col-12" (click)="submitPayment()" [disabled]="form.invalid">
              {{ "APP.SUBMIT_PAYMENT" | translate }}
            </button>
            <!-- A disabled button that does not say why is a dead end. Two
                 things are required and only one of them looks like a field. -->
            @if (form.invalid) {
            <p class="fs-7 text-muted mt-2 mb-0" data-testid="payment-blocked">
              @if (!form.value.bank_id) {
              {{ "APP.NEED_BANK" | translate }}
              } @else {
              {{ "APP.NEED_SLIP" | translate }}
              }
            </p>
            }
          </div>
          <div class="col-12">
            <button class="btn btn-outline-danger text-danger text-hover-white col-12" (click)="cancelOrder()">
              {{ "APP.CANCEL_PAYMENT" | translate }}
            </button>
          </div>
        </section>
      </div>
      } @if(transaction_info.transaction_status_id === 3){
      <div class="col-12 d-flex flex-row align-items-center gap-2 bg-light-success rounded p-3">
        <app-keenicon name="check-circle" class="fs-2qx text-success"></app-keenicon>
        <!-- The colon was printed unconditionally, so an order with no
             recorded verification time read "ตรวจสอบเรียบร้อย:" and then
             nothing — a sentence that looks cut off. -->
        <span class="fs-6 fw-semibold">
          {{ "APP.ORDER_APPROVED" | translate }}@if (transaction_info.verified_date) {<span class="fw-normal">:
            {{ transaction_info.verified_date | date : "dd/MM/yyyy HH:mm" }}
          </span>}
        </span>
      </div>
      } @if(transaction_info.transaction_status_id === 4){
      <div class="col-12 d-flex flex-row align-items-center gap-2 bg-light-danger rounded p-3">
        <app-keenicon name="cross-circle" class="fs-2qx text-danger"></app-keenicon>
        <span class="fs-6 fw-semibold text-danger">{{ "APP.ORDER_CANCELED" | translate }}
        </span>
      </div>
      }
    </div>

    <!----><!---->
  </div>
</div>